export default "__VITE_ASSET__D5jgnf3J__"